import React from "react";
import { default as ReactModal } from "react-modal";
import { ReactComponent as Closy } from "assets/svgs/closy.svg";
import clsx from "clsx/lite";

const Modal = ({
	title,
	isOpen,
	close,
	children,
	className,
	bodyClassName = "",
	overlayClassName,
	headerStyle,
	hideHeader = false,
	hideClose = false,
	closeDisabled = false,
}) =>
	isOpen ? (
		<ReactModal
			isOpen={isOpen}
			onRequestClose={closeDisabled ? undefined : close}
			contentLabel={`${title} modal`}
			className={`styled-modal ${className ?? ""}`}
			overlayClassName={`styled-modal-overlay ${overlayClassName ?? ""}`}
			shouldCloseOnOverlayClick={!closeDisabled}
			shouldCloseOnEsc={!closeDisabled}
			ariaHideApp={false}
		>
			{!hideHeader && (
				<div className="flex flex-col py-2 mt-4">
					<div className={clsx("flex px-8 md:px-12", headerStyle)}>
						<p className="text-body">{title}</p>
						{!hideClose && (
							<button className="p-1 ml-auto" onClick={close}>
								<Closy />
							</button>
						)}
					</div>
				</div>
			)}
			{/* TODO: scroll from this div */}
			<div className={clsx(bodyClassName)}>{children}</div>
		</ReactModal>
	) : (
		<></>
	);

export default Modal;
